import { writable } from "svelte/store";
export const PRODUCTS = [
  {
    id: 1,
    imgSrc: "images/products/p-1.jpg",
    name: "Mountain Twin Snowboard",
    price: "8999",
    isSale: true,
    discount: 10,
  },
  {
    id: 2,
    imgSrc: "images/products/p-2.jpg",
    name: "Freeride Snowboard",
    price: "7499",
  },
  {
    id: 3,
    imgSrc: "images/products/p-3.jpg",
    name: "All-Mountain Snowboard",
    price: "5999",
  },
  {
    id: 4,
    imgSrc: "images/products/p-4.jpg",
    name: "Powder Slayer Snowboard",
    price: "8499",
  },
  {
    id: 5,
    imgSrc: "images/products/p-5.jpg",
    name: "Freestyle Park Snowboard",
    price: "4299",
  },
  {
    id: 6,
    imgSrc: "images/products/p-6.jpg",
    name: `Women's All-Mountain Snowboard`,
    price: "5799",
  },
  {
    id: 7,
    imgSrc: "images/products/p-7.jpg",
    name: "Freeride Splitboard",
    price: "9999",
  },
  {
    id: 8,
    imgSrc: "images/products/p-8.jpg",
    name: "Youth Snowboard",
    price: "2999",
  },
  {
    id: 9,
    imgSrc: "images/products/p-9.jpg",
    name: "All-Mountain Freestyle Snowboard",
    price: "5499",
    isSale: true,
    discount: 10,
  },
  {
    id: 10,
    imgSrc: "images/products/p-10.jpg",
    name: "Big Mountain Snowboard",
    price: "7699",
  },
  {
    id: 11,
    imgSrc: "images/products/p-11.jpg",
    name: "Beginner Snowboard",
    price: "3499",
  },
  {
    id: 12,
    imgSrc: "images/products/p-12.jpg",
    name: "Park Jib Snowboard",
    price: "3899",
  },
  {
    id: 13,
    imgSrc: "images/products/p-13.jpg",
    name: "Backcountry Snowboard",
    price: "6799",
  },
  {
    id: 14,
    imgSrc: "images/products/p-14.jpg",
    name: "Splitboard Package",
    price: "11799",
  },
  {
    id: 15,
    imgSrc: "images/products/p-15.jpg",
    name: "Supre Package",
    price: "19",
  },
  {
    id: 16,
    imgSrc: "images/products/p-16.jpg",
    name: "Nano Package",
    price: "199",
  },
];

export const productStore = writable(PRODUCTS);
